// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setReportModules = createAction('[Custom PDF Report Builder] Set Report Modules', props());
export const addPage = createAction('[Custom PDF Report Builder] Add Page', props());
export const duplicatePage = createAction('[Custom PDF Report Builder] Duplicate Page', props());
export const removePage = createAction('[Custom PDF Report Builder] Remove Page', props());
export const movePage = createAction('[Custom PDF Report Builder] Move Page', props());
export const addModule = createAction('[Custom PDF Report Builder] Add Module', props());
export const updateModule = createAction('[Custom PDF Report Builder] Update Module', props());
export const removeModule = createAction('[Custom PDF Report Builder] Remove Module', props());
export const moveModule = createAction('[Custom PDF Report Builder] Move Module', props());
